const columnTitleMap = {
  name: "Name",
  createdAt: "Date created",
  modifiedAt: "Date modified",
  comments: "Comments",
  kind: "Kind",
  preview: "Preview",
  size: "Size",
  tags: "Tags",
  url: "URL",
  createdBy: "Creator/added by"
};

export { columnTitleMap };
//# sourceMappingURL=columnTitleMap.js.map
